import React, { Component } from 'react';
import styled from 'styled-components';
import {
  BackButton,
  Heading as DefaultHeading,
  Progress,
  Button,
  ProductList,
  ProductListItem,
  ProductListItemHeading,
  ProductListItemMetadata,
  ProductListItemProgressContainer,
  ProductListItemActionsContainer,
  ProductListItemHeadingCell,
  Text,
} from 'prospect-path-components';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import moment from 'moment';
import { history } from '../store';
import NotFound from './not-found';
import getTeamUsers from '../actions/GetTeamUsers';
import acceptUser from '../actions/product-management/AcceptUser';

const Heading = styled(DefaultHeading)`
  font-size: 2.5rem;
`;

class TeamUsers extends Component {
  constructor(props) {
    super(props);

    this.getTeamId = this.getTeamId.bind(this);
    this.getTeam = this.getTeam.bind(this);
    this.hasTeamUsers = this.hasTeamUsers.bind(this);
    this.getTeamUsers = this.getTeamUsers.bind(this);
  }
  getTeamId() {
    return parseInt(this.props.currentTeamId);
  }
  getTeam() {
    return this.props.teams.find(team => team.id === this.getTeamId());
  }
  hasTeamUsers() {
    if (this.props.teamUsers.teamId === this.getTeamId()) {
      return true;
    }

    this.props.getTeamUsers(this.getTeamId());
    return false;
  }
  getTeamUsers() {
    return this.props.teamUsers.users;
  }
  render() {
    if (this.props.user.id === null) {
      window.location = `/login?redirect=/products/users`;
    }
    if (!this.props.loadingTeams && !this.props.userTeams.includes(this.getTeamId())) {
      return <NotFound />;
    }

    let users = '';
    if (this.hasTeamUsers()) {
      users = (
        <ProductList>
          {this.getTeamUsers().map((user) => (
            <ProductListItem key={user.id}>
              <ProductListItemHeadingCell>
                <ProductListItemHeading>
                  {user.email}
                </ProductListItemHeading>
                <ProductListItemMetadata>
                </ProductListItemMetadata>
              </ProductListItemHeadingCell>
              { user.pivot.team_role === 'super_admin' && <Text>Super Admin</Text>}
              { user.pivot.team_role === 'user' && <Text>User</Text>}
              { user.pivot.team_role === 'read_only' &&
                <ProductListItemActionsContainer>
                  <Button
                    onClick={() => { this.props.acceptUser(this.getTeamId(), user.id); }}
                  >
                    Accept User
                  </Button>
                </ProductListItemActionsContainer>
              }
            </ProductListItem>
          ))}
        </ProductList>
      );
    }

    return (
      <div>
        <div className="l-wrapper-content">
          <section className="l-wrapper-container">
            <header className="l-billing-header">
              <div>
                <Heading>Team Users</Heading>
              </div>
              <BackButton onClick={() => history.push(`/products`)} />
            </header>

            {users}
          </section>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  teams: state.teams.all,
  userTeams: state.teams.userTeams,
  loadingTeams: state.teams.loadingTeams,
  teamUsers: state.productManagement.teamUsers,
  currentTeamId: state.teams.currentTeam,
});

const mapDispatchToProps = dispatch => ({
  acceptUser: (teamId, userId) => dispatch(acceptUser(teamId, userId)),
  getTeamUsers: teamId => dispatch(getTeamUsers(teamId)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TeamUsers));
